// src/actions/channelActions.js
import { createAsyncThunk } from '@reduxjs/toolkit';
import { http } from '../api/http'; // central axios instance (runtime env + token)

// Create a new channel
export const createChannel = createAsyncThunk(
  'channels/createChannel',
  async ({ applicationId, incomingComponentId, outgoingComponentId }, { rejectWithValue }) => {
    try {
      const { data } = await http.post('/channels/create', {
        applicationId,           // ✅ keep sending applicationId
        incomingComponentId,
        outgoingComponentId,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Get all channels
export const getChannels = createAsyncThunk(
  'channels/getChannels',
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await http.get('/channels');
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Get a channel by ID
export const getChannelById = createAsyncThunk(
  'channels/getChannelById',
  async (channelId, { rejectWithValue }) => {
    try {
      const { data } = await http.get(`/channels/${channelId}`);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Update an existing channel
export const updateChannel = createAsyncThunk(
  'channels/updateChannel',
  async ({ channelId, incomingComponentId, outgoingComponentId }, { rejectWithValue }) => {
    try {
      const { data } = await http.put(`/channels/${channelId}`, {
        incomingComponentId,
        outgoingComponentId,
      });
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Delete a channel
export const deleteChannel = createAsyncThunk(
  'channels/deleteChannel',
  async (channelId, { rejectWithValue }) => {
    try {
      await http.delete(`/channels/${channelId}`);
      return { id: channelId };
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
